export const environment = {
  production: false,
  mainWebsite: 'https://yourwebbooker.com',
  translationId: '5d88988ecf78f843c7a711b4',
  translationUrl: 'https://localization-api.dispatchapi.io/api/Projects',
  libraryUrl: 'https://library.dispatchapi.io',
  apiUrl: 'https://s-order.dispatchapi.io',
  //apiUrl: 'http://localhost:3000',
   orderFormUrl: 'https://s-order.yourdriverapp.com',
  //orderFormUrl: 'http://localhost:3000',
  // TODO(quote-page): placeholder — the dedicated quote/payment page is being built in a sibling
  // app in parallel and its real URL is not known yet. Update this ONE value once it ships; every
  // "view your quote" link in this repo reads from here (see QuoteRequestService callers).
  quotePageUrl: '',
  pasUrl: 'https://pas.dispatchapi.io',
  ydaStripePublicKey: 'pk_test_51Hk3p7AAAqH6BJkpNpMpwWtSOW5HnpzPXNYImfzbuZilQtW7PAZ0bZcadDSPyul7CT9gEDrrEtt70JcMXcdPq9h3004NacQkCX',
  customDomains: {
    'www.gatwickcars.com': '625d40d7ec6af2581a363fc3',
    'order.gatwickcars.com': '625d40d7ec6af2581a363fc3',
    'www.heathrowcars.com': '625d40d7ec6af2581a363fc3',
    'order.heathrowcars.com': '625d40d7ec6af2581a363fc3',
    'order.roadrunnersgroup.com': '625d40d7ec6af2581a363fc3',
    'booking.schipholtraveltaxi.nl': '5dd66bfba22b8cc7a3cced8e',
    'booking.schipholbusinesstaxi.nl': '5dd66c06a22b8cc7a3ccf33a',
    'www.vfashuttle.com': '62f67d523019db31b30f1738',
    'www.shuttles.co.zw': '62f6c6a2c326cc0ec2bfd83c',
    'booking.taxiserviceairportrome.com': '645d0cc10c2023e5ffd26264',
    'booking.tsairportransfers.com': '63a491cd88b78c65535a565f',
    'partnerbooking.taxiserviceairportrome.com': '64d15bd4c20eea1e8f3b9ef3',
  },
  langNames: {
    'en': {
      name: 'English',
      code: 'en-EN',
      short: 'en',
    },
    'us': {
      name: 'United States',
      flag: 'us',
      code: 'en-US',
      short: 'en',
    },
    'in': {
      name: 'India english',
      flag: 'in',
      code: 'en-IN',
      short: 'en',
    },
    'de': {
      name: 'Deutsch',
      code: 'de-DE',
      short: 'de'
    },
    'fr': {
      name: 'France',
      code: 'fr-FR',
      short: 'fr'
    },
    'es': {
      name: 'Espange',
      code: 'es-ES',
      short: 'es'
    },
    'hi': {
      name: 'Hindi',
      code: 'hi-NI',
      short: 'hi',
      flag: 'in'
    },
    'it': {
      name: 'Italiano',
      code: 'it-IT',
      short: 'it',
    },
    'nl': {
      name: 'Nederlands',
      code: 'nl-NL',
      short: 'nl'
    },
    'pt': {
      name: 'Polish',
      code: 'pt-PT',
      short: 'pt'
    },
    'el': {
      name: 'Greek',
      code: 'el-GR',
      short: 'el',
      flag: 'gr'
    },
    'sk': {
      name: 'Slovakia',
      code: 'sk-SK',
      short: 'sk'
    },
    'sl': {
      name: 'Slovenia',
      code: 'sl-SL',
      short: 'sl',
      flag: 'si'
    },
    'uk': {
      name: 'українська',
      code: 'uk-UK',
      short: 'uk',
      flag: 'ua'
    },
    'ar': {
      name: 'عربى',
      code: 'ar-100',
      flag: 'sa',
      short: 'ar'
    },
    'ja': {
      name: 'Japanese',
      code: 'jp-JA',
      short: 'jp'
    },
    'zh': {
      name: 'Chinese',
      code: 'zh-Hans-CN',
      short: 'cn'
    }
  }
};
